import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { useToasts } from "react-toast-notifications";
import ModalAvertissement from "./ModalAvertissement";

import { MDBBtn } from "mdbreact";

const API_URL = process.env.REACT_APP_API_URL;

function Representant(props) {
  const [representant, setRepresentant] = useState();
  const [showRep, setShowRep] = useState(false);
  const [marque_nom, setMarqueNom] = useState();
  const [representant_nom, setRepresentantNom] = useState();
  const [representant_telephone, setRepresentantTelephone] = useState();
  const [representant_email, setRepresentantEmail] = useState();
  const fournisseur_id = props.fournisseurId;
  const fournisseur_type = props.type;
  const refresh = props.refresh;
  const setRefresh = props.setRefresh;
  const [showAvertissement, setShowAvertissement] = useState(false);

  const { addToast } = useToasts();

  const TOKEN_KEY = "jwt";
  const token = localStorage.getItem(TOKEN_KEY);
  const loggedIn = useSelector((state) => state.login);
  const handleShowAvertissement = () => setShowAvertissement(true);

  useEffect(() => {
    function getRepresentants() {
      axios
        .get(
          `${API_URL}/api/notes/representant/${fournisseur_type}/${fournisseur_id}`,
          { headers: { authorization: `Bearer ${token}` } }
        )
        .then((res) => res.data)
        .then((data) => {
          setRepresentant(data);
        })
        .catch((e) => {
          if (e.response.status === 401) {
            //instruction vide volontaire
          } else {
            addToast(`Erreur : ${e.message}`, {
              appearance: "error",
              autoDismiss: true,
            });
          }
        });
    }
    getRepresentants();
  }, [refresh]);

  function handleSubmit() {
    axios
      .put(
        `${API_URL}/api/notes/representant/${fournisseur_id}`,
        {
          fournisseur_id,
          fournisseur_type,
          marque_nom,
          representant_nom,
          representant_telephone,
          representant_email,
        },
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        addToast("Représentant enregistré !", {
          appearance: "success",
          autoDismiss: true,
        });
        setShowRep(false);
        setMarqueNom();
        setRepresentantNom();
        setRepresentantTelephone();
        setRepresentantEmail();
        setRefresh(!refresh);
      })
      .catch((e) => {
        console.error(e);
        addToast(`Erreur : ${e.message}`, {
          appearance: "success",
          autoDismiss: true,
        });
      });
  }

  function handleDelete(key) {
    if (
      window.confirm("Êtes-vous sûr de vouloir supprimer ce représentant ?")
    ) {
      axios
        .delete(`${API_URL}/api/notes/representant/${key}`, {
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then(() => {
          addToast("Représentant supprimé !", {
            appearance: "success",
            autoDismiss: true,
          });
          setRefresh(!refresh);
        })
        .catch((e) => {
          console.error(e);
          addToast(`Erreur : ${e.message}`, {
            appearance: "success",
            autoDismiss: true,
          });
        });
    }
  }

  return (
    <div>
      <table className="representantsTable">
        <thead>
          <tr>
            <th className="representantsTableHead">
              <b>Marque</b>
            </th>
            <th className="representantsTableHead">
              <b>Nom</b>
            </th>
            <th className="representantsTableHead">
              <b>Téléphone</b>
            </th>
            <th className="representantsTableHead">
              <b>Email</b>
            </th>
            <th className="representantsTableHead"></th>
          </tr>
        </thead>
        <tbody>
          {representant &&
            representant.map((r) => {
              return (
                <tr className="representantsTableRow">
                  <td className="representantsTableCell">{r.marque_nom}</td>
                  <td className="representantsTableCell">
                    {r.representant_nom}
                  </td>
                  <td className="representantsTableCell">
                    {r.representant_telephone}
                  </td>
                  <td className="representantsTableCell">
                    <a href={`mailto:${r.representant_email}`}>
                      {r.representant_email}
                    </a>
                  </td>
                  <td className="representantsTableCell">
                    <button
                      className="linkButton"
                      value={r.id}
                      onClick={(e) => {
                        handleDelete(e.target.value);
                      }}
                    >
                      Supprimer
                    </button>
                  </td>
                </tr>
              );
            })}
          {showRep && (
            <tr>
              <td>
                <input onChange={(e) => setMarqueNom(e.target.value)} />
              </td>
              <td>
                <input onChange={(e) => setRepresentantNom(e.target.value)} />
              </td>
              <td>
                <input
                  onChange={(e) => setRepresentantTelephone(e.target.value)}
                />
              </td>
              <td>
                <input onChange={(e) => setRepresentantEmail(e.target.value)} />
              </td>
              <td>
                <MDBBtn color="primary" onClick={() => handleSubmit()}>
                  Ajouter
                </MDBBtn>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {!marque_nom && (
        <div>
          <i>Aucun représentant n'a été ajouté pour le moment.</i>
          <br />
          <br />
        </div>
      )}
      <MDBBtn
        outline={showRep ? true : false}
        color="primary"
        onClick={() =>
          loggedIn ? setShowRep(!showRep) : handleShowAvertissement()
        }
      >
        {showRep ? "Annuler la saisie" : "Ajouter un représentant"}
      </MDBBtn>
      <ModalAvertissement
        showAvertissement={showAvertissement}
        setShowAvertissement={setShowAvertissement}
      />
    </div>
  );
}

export default Representant;
